import Resources from '@/components/resources/resources';
import { Flex } from '@cmpsr/components';
import { PropsWithChildren } from 'react';
import useIsMobile from '@/hooks/use-is-mobile';

export default function TestDetailsBody({ children }: PropsWithChildren) {
  const isMobile = useIsMobile();
  return (
    <Flex gap="spacer-9" display={{ base: 'block', lg: 'flex' }}>
      <Flex as="main" flexDirection="column" gap={4}>
        {children}
      </Flex>
      {!isMobile && (
        <Flex
          as="aside"
          flexDir="column"
          mt={{ base: 'spacer-8', lg: '0' }}
          gap="spacer-6"
          minWidth={{ base: 'full', lg: '316px', xl: '364px', xxl: '400px' }}
        >
          <Resources />
        </Flex>
      )}
    </Flex>
  );
}
